module.exports = __webpack_public_path__ + "img/compasses.f78e93a1.png";